/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_Pdf_SubtitleInputs */

const en_mobile_upload_pdf_subtitle = /** @type {(inputs: Mobile_Upload_Pdf_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a file from your phone`)
};

const es_mobile_upload_pdf_subtitle = /** @type {(inputs: Mobile_Upload_Pdf_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un archivo de tu teléfono`)
};

/**
* | output |
* | --- |
* | "Select a file from your phone" |
*
* @param {Mobile_Upload_Pdf_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_pdf_subtitle = /** @type {((inputs?: Mobile_Upload_Pdf_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_Pdf_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_pdf_subtitle(inputs)
	return en_mobile_upload_pdf_subtitle(inputs)
});